// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllData = createAsyncThunk('appUsers/getAllData', async () => {
  const response = await axios.get('/users')
  return response.data
})

export const getData = createAsyncThunk('appUsers/getData', async params => {
  const response = await axios.get('/users', {params})
  return {
    params,
    data: response.data,
    totalPages: response.data.length
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get(`/users/${id}`)
  return response.data.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  const response = await axios.post('/users/create', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return response.data.user
})

export const addMerchantUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  const response = await axios.post('/users/createmerchantuser', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return response.data.user
})

export const updateUser = createAsyncThunk('appUsers/updateUser', async (data, { dispatch, getState }) => {
  const response = await axios.put(`/users/${data.UUID}`, data.user)
  await dispatch(getUser(data.UUID))
  await dispatch(getData(getState().users.params))
  return response.data.user
})

export const getUserFee = createAsyncThunk('appUsers/getUserFee', async (data) => {
  const response = await axios.get(`/userfee/getfeebyuser/${data.UUID}`)
  return response.data.data
})

export const createUserFee = createAsyncThunk('appUsers/createUserFee', async (data, { dispatch, getState }) => {
  const response = await axios.post(`/userfee/createfee?isChild=${data.isChild}`, data.user)
  await dispatch(getUser(data.UUID))
  await dispatch(getData(getState().users.params))
  return response.data.user
})

export const editUserFee = createAsyncThunk('appUsers/editUserFee', async (data, { dispatch, getState }) => {
  const response = await axios.put(`/userfee/updatefee/${data.id}?childId=${data.childId}`, data.user)
  await dispatch(getUser(data.UUID))
  await dispatch(getData(getState().users.params))
  return response.data.user
})

export const deleteUserFee = createAsyncThunk('appUsers/deleteUserFee', async (data) => {
  console.log("inside deleteUserfee", data)
  const response = await axios.post(`/userfee/deletefee/${data.id}?childId=${data.childId}`)
  return response.data.data
})

export const suspendUser = createAsyncThunk('appUsers/suspendUser', async (data, { dispatch, getState }) => {
  const response = await axios.patch(`/users/updatestatus/${data.UUID}`, {IsActive: data.IsActive})
  await dispatch(getUser(data.UUID))
  await dispatch(getData(getState().users.params))
  return response
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const changePassword = createAsyncThunk('appUsers/changePassword', async (pwd, { dispatch, getState, rejectWithValue }) => {
  try {
    const response = await axios.patch(`/users/changepassword/${pwd.UUID}`, {Password: pwd.password})
    await dispatch(getData(getState().users.params))
    return response.data
  } catch (error) {
    // Extract error message from response
    const errorMessage = error.response?.data?.message || error.response?.data?.errors?.[0] || error.message || 'Failed to change password'
    return rejectWithValue({ message: errorMessage, errors: error.response?.data?.errors })
  }
})

export const addAuxLBRules = createAsyncThunk('appUsers/rules', async (data, { dispatch, getState }) => {
  console.log(data)
      const response = await axios.post(`/watchdog/rules/${data.UUID}`, {userId: data.UserId, watchDogRules: data.watchDogRules})
  await dispatch(getUser(data.UUID))
  await dispatch(getData(getState().users.params))
  return response
})

export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.data.data.count
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appUsersSlice.reducer
